import React from 'react';

import PersonalisationSlotHeader from '../PersonalisationSlotHeader';

/**
 * PersonalisationPageContentSlot component displays an informational slot in the personalisation journey.
 *
 * @param {Object} props - The component props
 * @param {Object} props.slot - The slot data
 * @returns {import('react').JSX.Element} The rendered component
 */
export default function PersonalisationPageContentSlot({ slot }) {
  return (
    <div>
      <PersonalisationSlotHeader slot={slot} processHeading={false} />
      <div className={'rte'} dangerouslySetInnerHTML={{ __html: slot.pageContent.body }} />
    </div>
  );
}
